import { apiClient } from "./client";
export const ftpAPI = {
  createUser(username: string, password?: string) {
    return apiClient.post("/ftp/users", {
      username,
      ...(password ? { password } : {}),
    });
  },
  deleteUser(username) {
    return apiClient.delete(`/ftp/users/${username}`);
  },
  userDetail() {
    return apiClient.get<{ task_id: string }>("/ftp/users/detail");
  },
  mountProject(project, username) {
    return apiClient.post("/ftp/mount/oasys_project", {
      project, username
    });
  },
  unmountProject(project, username) {
    return apiClient.delete("/ftp/mount/oasys_project", {
      data: { project, username },
    });
  },
};
